// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".salon-general-form{max-width:700px;width:100%}.salon-general-form .ant-form-item,.salon-general-form .form-group-input{width:100%;max-width:447px}.salon-general-form .form-input{display:flex;justify-content:flex-end;width:100%}.salon-general-form .form-input .modal_label{margin-top:10px;white-space:nowrap;font-weight:400;margin-right:16px;color:#595959;font-size:16px}", ""]);
// Exports
module.exports = exports;
